import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { NavigationExtras, Router } from "@angular/router";
import { IonInfiniteScroll, LoadingController, NavController } from '@ionic/angular';
import { AccountModel } from 'src/models/accounts/account';
import { ProfileModel } from 'src/models/profile/profile';
import { BranchModel } from 'src/models/system/branch-collection/branch';
import { CrudService } from '../../admin/services/crud/crud.service';
import { FireSQL } from 'firesql';
import * as firebase from 'firebase/app';
import 'firesql/rx';
import { map, switchMap, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { async } from '@angular/core/testing';
import { BranchTypeCompose, ProfileBranchModel } from 'src/models/system/branch-collection/profile-branch';
import { ClinicModel } from 'src/models/system/clinic/clinic';
import { ProfileUsersModel } from 'src/models/profile/profile-users/profile-users';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../expert-appointments-for-subscriber/core/loader.service';

@Component({
  selector: 'app-search-bar-doctor',
  templateUrl: './search-bar-doctor.component.html',
  styleUrls: ['./search-bar-doctor.component.scss'],
})
export class SearchBarDoctorComponent implements OnInit {
  tnc: string = "tc";

  @Input() title: string;

  @ViewChild(IonInfiniteScroll, { static: true }) infiniteScroll: IonInfiniteScroll;
  url: string;
  itemListData = [];
  accountsResOfName = [] as { obj: AccountModel, title: string, branchTitle: string, profileId: firebase.firestore.DocumentReference }[]
  accountsResOfSurname = [] as { obj: AccountModel, title: string, branchTitle: string, profileId: firebase.firestore.DocumentReference }[];
  mergeExpertRes = [] as { obj: AccountModel, title: string, branchTitle: string, profileId: firebase.firestore.DocumentReference }[];
  pathsOfBranches = [] as { title: string, ref: string }[];
  pathsOfClinics = [] as { name: string, id: string }[];
  dataArr = ["ümit", "ipek", "savaş", "gülcan", "mehmet"];
  fireSQL = new FireSQL(firebase.firestore());
  isItemAvailable = false;
  items = [];
  limit: number = 10;

  branchAccountRes2 = [] as { obj: AccountModel, title: string, branchTitle: string, profileId: firebase.firestore.DocumentReference }[];


  constructor(private route: Router,
    private profileService: CrudService<object, ProfileModel>,
    private accountService: CrudService<object, AccountModel>,
    private branchService: CrudService<object, BranchTypeCompose>,
    private profileBranchservice: CrudService<object, ProfileBranchModel>,
    private firestore: AngularFirestore,
    private navCtrl: NavController,
    private loadingController: LoadingController,
    public translate: TranslateService,
    private ionLoader: LoaderService,
  ) { }

  ngOnInit() {
    this.loadData(false, "");

  }

  showLoader() {
    this.ionLoader.presentLoading();
  }

  hideLoader() {
    this.ionLoader.dismiss();
  }


  initializeItems() {
    this.items = ["Ram", "gopi", "dravid"];
  }

  arrayUnique(array: { obj: AccountModel, title: string, branchTitle: string, profileId: firebase.firestore.DocumentReference }[]) {
    var a = array.concat();
    console.log(a);

    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i].obj.name === a[j].obj.name &&
          a[i].obj.surname === a[j].obj.surname &&
          a[i].obj.gender === a[j].obj.gender &&
          a[i].obj.height === a[j].obj.height &&
          a[i].obj.weight === a[j].obj.weight &&
          a[i].obj.bloodGroup === a[j].obj.bloodGroup)
          a.splice(j--, 1);
      }
    }

    return a;
  }




  arrayUniqueBranch(array: BranchModel[]) {
    var a = array.concat();
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i].title === a[j].title)
          a.splice(j--, 1);
      }
    }

    return a;
  }





  async getItems(ev: any) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    const val: string = ev.target.value;


    // if the value is an empty string don't filter the items
    if (val && val.trim() !== '' && val.length >= 3) {
      this.showLoader();

      const loading = await this.loadingController.create({
        message: ''
      });
      await loading.present();

      this.mergeExpertRes = [];
      this.firestore.collection('accounts', ref => ref.where('isExpert', '==', true).where('confirmStatusByAdmin', '==', true).orderBy('name').startAt(val).endAt(val + '\uf8ff').limit(this.limit).startAfter(val).endBefore(val + '\uf8ff')).snapshotChanges().pipe(
        map(changes => {
          changes.map(a => {
            let accId = a.payload.doc.id;
            this.profileService.findFirstRefPromise('accounts', accId, 'profile').then(resPrfl => {
              this.profileBranchservice.findFirstRefPromise('accounts/' + accId + '/profile', resPrfl.refId, 'profileBranches').then(profileBranch => {
                this.branchService.findFirstRefPromise('accounts/' + accId + '/profile/' + resPrfl.refId + '/profileBranches', profileBranch.refId, 'expertBranches').then(expertBarnch => {
                  expertBarnch.obj.branchId.get().then(result => {
                    let proRef = this.firestore.collection('accounts').doc(accId).collection('profile').doc(resPrfl.refId).ref;
                    this.mergeExpertRes.push({ obj: a.payload.doc.data() as AccountModel, title: resPrfl.obj.title, branchTitle: result.data().title, profileId: proRef });
                    this.mergeExpertRes = this.arrayUnique(this.mergeExpertRes);
                  })
                }).catch(errBranch => {
                  console.log(errBranch);
                });
              }).catch(errPBranch => {
                console.log(errPBranch);
              });
            }).catch(errPrfl => {
              console.log(errPrfl);
            });
          })
        })
      ).subscribe(res => {
        console.log(res);
        loading.dismiss();
      });


      const loadingTwo = await this.loadingController.create({
        message: ''
      });
      await loading.present();


      let arrBranchIds = [];
      let arrBranchRefIds = [];
      this.firestore.collectionGroup('branches', ref => ref.orderBy('title').startAt(val).endAt(val + '\uf8ff').limit(this.limit)).snapshotChanges().pipe(
        map(changes => {
          changes.map(a => {
            let branchId = a.payload.doc.ref.path;
            arrBranchIds.push(branchId);
          })
        })
      ).subscribe(res => {
        arrBranchIds.forEach((item) => {
          let slc = item.split('/');
          let refId = this.firestore.collection(slc[0]).doc(slc[1]).collection(slc[2]).doc(slc[3]).ref;
          arrBranchRefIds.push(refId);
        });
        console.log(arrBranchRefIds);
        if (arrBranchRefIds.length > 0) {
          this.firestore.collectionGroup<BranchTypeCompose>('expertBranches', ref => ref.where('branchId', 'in', arrBranchRefIds)).snapshotChanges().pipe(
            map(changes => {
              changes.map(x => {

                let path = x.payload.doc.ref.path;

                let str = path.split('/');

                let accountId = str[1];

                let profileId = str[3];

                this.firestore.collection<AccountModel>('accounts', ref => ref.where(firebase.firestore.FieldPath.documentId(), '==', accountId)).get().toPromise().then(ResAcc => {
                  this.profileService.findFirstRefPromise('accounts', accountId, 'profile').then(resProfile => {
                    let proRef = this.firestore.collection('accounts').doc(accountId).collection('profile').doc(resProfile.refId).ref;
                    x.payload.doc.data().branchId.get().then(resB => {
                      this.mergeExpertRes.push({ obj: ResAcc.docs[0].data() as AccountModel, profileId: proRef, title: resProfile.obj.title, branchTitle: resB.data().title });
                      this.mergeExpertRes = this.arrayUnique(this.mergeExpertRes);
                    });
                  }).catch(errProfile => {
                    console.log(errProfile);
                  })
                }).catch(ErrAc => {
                  console.log(ErrAc);
                });
              })
            })
          ).subscribe(resT => {
            console.log(resT);

          });

        }
        loadingTwo.dismiss();
      });










      const branchesQuery = this.fireSQL.query<BranchModel>(`
      SELECT *
      FROM GROUP branches
      WHERE title LIKE '${val}%'
      LIMIT ${this.limit}
    `);


      let branchTitles: string[] = [];
      const loadingThree = await this.loadingController.create({
        message: ''
      });
      await loading.present();

      branchesQuery.then(queryRes => {
        queryRes.forEach((item) => {
          console.log(item);
          if (item) {
            branchTitles.push(item.title);
          }
        });
        console.log(branchTitles);



        if (branchTitles && branchTitles.length > 0) {

          this.pathsOfBranches = [];
          this.firestore.collectionGroup<BranchModel>('branches', ref => ref.where('title', 'in', branchTitles)).snapshotChanges().pipe(
            map(changes => {
              return changes.map(a => {
                let data = a.payload.doc.ref.path;
                console.log(data);

                let str = data.split('/');
                let tmp = this.firestore.collection(str[0]).doc(str[1]).collection(str[2]).doc(str[3]).ref;
                return this.pathsOfBranches.push({ title: a.payload.doc.data().title, ref: data })
              })
            })
          ).subscribe(resSubscribe => {
            console.log(resSubscribe);
          });
        }

        loadingThree.dismiss();

      });




      const clinicsQuery = this.fireSQL.query<ProfileUsersModel>(`
      SELECT *
      FROM GROUP profileUsers
      WHERE name LIKE '${val}%' OR name = '${val}'
      LIMIT ${this.limit}
      `);


      let clinicNames: string[] = [];

      const loadingFour = await this.loadingController.create({
        message: ''
      });
      await loading.present();

      clinicsQuery.then(queryRes => {
        queryRes.forEach((item) => {
          console.log(item);
          if (item) {
            clinicNames.push(item.name);
          }
        });
        console.log(clinicNames);

        if (clinicNames && clinicNames.length > 0) {
          this.pathsOfClinics = [];
          this.firestore.collectionGroup<ProfileUsersModel>('profileUsers', ref => ref.where('name', 'in', clinicNames)).snapshotChanges().pipe(
            map(changes => {
              return changes.map(a => {
                let data = a.payload.doc.ref.path;
                console.log(data);
                this.pathsOfClinics.push({ name: a.payload.doc.data().name, id: data })
                return this.pathsOfClinics;
              })
            })
          ).subscribe(resSubscribe => {
            console.log(this.pathsOfClinics);
            console.log(resSubscribe);
          });
        }


        loadingFour.dismiss();


      });


      this.isItemAvailable = true;
      this.items = this.items.filter((item) => {
        return (item.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    } else {
      this.isItemAvailable = false;
    }
  }


  expertDetailSearch() {
    this.route.navigate(['expert-search-in-detail']);
  }


  doctorProfile(profileRef: firebase.firestore.DocumentReference) {
    console.log(profileRef);
    return;
    
    let navigationExtras: NavigationExtras = {
      state: {
        profilePath: profileRef.path,
        profileId: profileRef.id
      }
    };
    this.navCtrl.navigateForward(['doctorprofile'], navigationExtras);
    /*   
      let profileObj
      profileRef.get().then(res => {
         profileObj = res.data() as ProfileModel;
  
      }).catch(err => {
        console.log(err);
      });
      console.log(profileObj);
        
      let navigationExtras: NavigationExtras = {
        state: {
            profile: JSON.stringify(profileObj),
            profileId: profileRef.id
        }
    };
    this.navCtrl.navigateForward(['doctorprofile'], navigationExtras); */
    //this.route.navigate(['doctorprofile']);
  }

  clinicDetail(clinicRef: string) {
    let navigationExtras: NavigationExtras = {
      state: {
        clinicId: clinicRef
      }
    };
    this.navCtrl.navigateForward(['clinic-detail'], navigationExtras);
  }

  branchesPage(branchRef: string) {
    let navigationExtras: NavigationExtras = {
      state: {
        branchId: branchRef
      }
    };
    this.navCtrl.navigateForward(['branch-detail'], navigationExtras);
  }

  loadData(isFirstLoad, event) {

    this.itemListData = [];
    this.dataArr.forEach((item) => {
      this.itemListData.push(item);
    });
    console.log(this.itemListData);


    if (isFirstLoad)
      event.target.complete();
  }
  doInfinite(event) {
    this.loadData(true, event);
  }




}
